import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">用户口碑</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            读者真实评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            来自韩漫爱好者的真实反馈，听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((testimonial, index) => (
            <article
              key={testimonial.id}
              className={`bg-background-50 rounded-lg p-6 ${index === 5 ? 'opacity-60' : ''}`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < testimonial.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {testimonial.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-5">
                {testimonial.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                  <img
                    src={testimonial.avatarUrl}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">{testimonial.name}</p>
                  <p className="text-[10px] text-foreground-500 whitespace-nowrap">{testimonial.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}